import { DateTime } from "luxon";
import { FC, useState } from "react";

import { Controls, ControlsButton } from "@/components/Controls";
import DateRangeFilter from "@/components/DateRangeFilter";

const periods = ["1 day", "7 days", "1 month", "3 months", "1 year", "All"];

interface Props {
  selectedDateRange: {
    rangeStart?: DateTime | undefined;
    rangeEnd?: DateTime | undefined;
  };
  setSelectedDateRange: React.Dispatch<
    React.SetStateAction<{
      rangeStart?: DateTime | undefined;
      rangeEnd?: DateTime | undefined;
    }>
  >;
}

const DateRangeFilterWithPresets: FC<Props> = ({
  selectedDateRange,
  setSelectedDateRange,
}) => {
  const now = DateTime.now();

  const [activePeriod, setActivePeriod] = useState<string>(periods[1]);

  const onPeriodChange = (period: string) => {
    setActivePeriod(period);

    const renderPrevDay = () => {
      switch (period) {
        case "1 day":
          return now.minus({
            days: 1,
          });
        case "7 days":
          return now.minus({
            days: 7,
          });
        case "1 month":
          return now.minus({
            month: 1,
          });
        case "3 months":
          return now.minus({
            month: 3,
          });
        case "1 year":
          return now.minus({
            year: 1,
          });
        default:
          return undefined;
      }
    };

    setSelectedDateRange({
      rangeStart: renderPrevDay(),
      rangeEnd: now,
    });
  };

  return (
    <>
      <Controls>
        {periods.map((period, index) => (
          <ControlsButton
            key={index}
            active={period === activePeriod}
            onClick={() => onPeriodChange(period)}
          >
            {period}
          </ControlsButton>
        ))}
      </Controls>
      <DateRangeFilter
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        setActivePeriod={setActivePeriod}
      />
    </>
  );
};

export default DateRangeFilterWithPresets;
